import React from 'react'
import BaseSelectPanel from './BaseSelectPanel'
import FeatureSelectModal from '@pc/components/Works/Panel/selectModal/FeatureSelectModal'

import EmphasisHeading from '@pc/components/Works/Panel/shared/heading/EmphasisHeading'
import ButtonGroup from '@pc/components/Works/Panel/shared/button/ButtonGroup'
import ConditionParagraph from '@pc/components/Works/Panel/shared/ConditionParagraph'

import buildConditionWords from '@pc/components/Works/Panel/util/buildConditionWords'
import type { SearchParamsAttributes, ConditionReducer } from '@pc/components/Works/Panel/type'

interface PropsType {
  params: SearchParamsAttributes
  conditionReducer: ConditionReducer
}

const FeatureSelectPanel = (props: PropsType) => {
  const { params, conditionReducer } = props
  const featureTitles = [
    conditionReducer.attributes.condition_title_maps.free_word,
    conditionReducer.attributes.condition_title_maps.keepup_day,
    conditionReducer.attributes.condition_title_maps.keepup_hour,
    conditionReducer.attributes.condition_title_maps.time_slots,
    conditionReducer.attributes.condition_title_maps.custom_codes,
    conditionReducer.attributes.condition_title_maps.features,
    conditionReducer.attributes.condition_title_maps.welcome,
    conditionReducer.attributes.condition_title_maps.except_haken,
    conditionReducer.attributes.condition_title_maps.except_medical_services,
    conditionReducer.attributes.condition_title_maps.accept_highschool_students,
    conditionReducer.attributes.condition_title_maps.except_night_work
  ]
    .flat()
    .filter((v): v is string => v != null)

  return (
    <BaseSelectPanel>
      <EmphasisHeading>こだわり条件</EmphasisHeading>
      <ConditionParagraph>{buildConditionWords(featureTitles)}</ConditionParagraph>
      <ButtonGroup>
        <FeatureSelectModal params={params} />
      </ButtonGroup>
    </BaseSelectPanel>
  )
}

export default FeatureSelectPanel
